"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var phocus_1 = require("phocus");
var action_1 = require("../action/action");
var phocus_context_1 = require("../phocus-context/phocus-context");
var key_command_1 = require("./key-command");
var phocus_button_1 = require("../phocus-button/phocus-button");
phocus_1.ActionContextService.addContext("keybinding-modal", {
    actions: {
        rebind: new action_1.Action({
            name: "Change Hotkey",
            shortDocumentation: "Rebind the hotkey for this action",
            searchTerms: ["remap", "rebind", "change", "hotkey"],
            actOn: function (c) { return c.startRemapping(); },
            defaultKeys: ["c"]
        }),
        unmap: new action_1.Action({
            name: "Remove Hotkey",
            shortDocumentation: "No key will perform this action",
            searchTerms: ["remap", "rebind", "change", "hotkey"],
            actOn: function (c) {
                phocus_1.ActionContextService.unmapAction(c.props.action);
                phocus_1.ActionContextService.triggerAction("closeModal");
            },
            defaultKeys: ["r"]
        }),
        unremap: new action_1.Action({
            name: "Restore defaults",
            shortDocumentation: "Restore the default hotkeys for this action",
            searchTerms: ["remap", "rebind", "change", "hotkey", "defaults"],
            actOn: function (c) {
                phocus_1.ActionContextService.unremapAction(c.props.action);
                phocus_1.ActionContextService.triggerAction("closeModal");
            },
            defaultKeys: ["d"]
        })
    }
});
var RebindingModal = /** @class */ (function (_super) {
    __extends(RebindingModal, _super);
    function RebindingModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            remapping: false
        };
        _this.remap = function (e) {
            var newMapping = phocus_1.Hotkey.canonicalKeyFromEvent(e.nativeEvent);
            if (!newMapping)
                return;
            phocus_1.ActionContextService.remapAction(_this.props.action, newMapping);
            e.stopPropagation();
            e.preventDefault();
            _this.setState({ remapping: false });
            phocus_1.ActionContextService.triggerAction("closeModal");
        };
        return _this;
    }
    RebindingModal.prototype.startRemapping = function () {
        this.setState({ remapping: true });
    };
    RebindingModal.prototype.componentDidMount = function () {
        phocus_1.ActionContextService.setContext(ReactDOM.findDOMNode(this));
    };
    RebindingModal.prototype.render = function () {
        return (React.createElement(phocus_context_1.PhocusContext, { context: "keybinding-modal", argument: this, className: "phocus-keybinding-modal" },
            React.createElement("div", { className: "phocus-keybinding-modal--binding" },
                React.createElement("strong", null, this.props.action.name),
                ":",
                !this.state.remapping && React.createElement(key_command_1.KeyCommand, { action: this.props.action }),
                this.state.remapping && React.createElement("input", { onKeyDown: this.remap, autoFocus: true })),
            React.createElement("div", { className: "phocus-keybinding-modal--actions" },
                React.createElement(phocus_button_1.PhocusButton, { action: "rebind" }),
                React.createElement(phocus_button_1.PhocusButton, { action: "unmap" }),
                React.createElement(phocus_button_1.PhocusButton, { action: "unremap" }))));
    };
    return RebindingModal;
}(React.Component));
exports.RebindingModal = RebindingModal;
//# sourceMappingURL=rebinding-modal.js.map